/**
 * RegionToggle — bouton de bascule Réunion ⇄ Mayotte.
 *
 * Utilisé sur la carte pour switcher la vue géographique.
 * La région courante est mémorisée dans localStorage (clé : `veyer_region`).
 */
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Globe, ChevronDown } from "lucide-react";

export const REGIONS = {
  reunion: {
    id: "reunion",
    label: "La Réunion",
    flag: "🌋",
    center: [-21.1151, 55.5364],
    zoom: 11,
  },
  mayotte: {
    id: "mayotte",
    label: "Mayotte",
    flag: "🏝️",
    center: [-12.8275, 45.166],
    zoom: 11,
  },
};

export function getStoredRegion() {
  try {
    const r = window.localStorage.getItem("veyer_region");
    if (r === "reunion" || r === "mayotte") return r;
  } catch {}
  return "reunion";
}

export function setStoredRegion(region) {
  try {
    window.localStorage.setItem("veyer_region", region);
  } catch {}
}

export default function RegionToggle({ region, onChange, compact = false }) {
  const current = REGIONS[region] || REGIONS.reunion;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          data-testid="region-toggle-btn"
          variant="outline"
          className={`floating-panel border-0 gap-1.5 text-xs font-semibold ${compact ? "h-9 px-2.5" : "h-10 px-3"}`}
          style={{ color: "#2D6A4F" }}
          title={`Région courante : ${current.label}`}
        >
          <Globe className="w-3.5 h-3.5" />
          <span className="text-base leading-none">{current.flag}</span>
          {!compact && <span>{current.label}</span>}
          <ChevronDown className="w-3 h-3 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="z-[9999]" sideOffset={8}>
        {Object.values(REGIONS).map((r) => (
          <DropdownMenuItem
            key={r.id}
            data-testid={`region-option-${r.id}`}
            onClick={() => {
              if (r.id !== region) onChange(r.id);
            }}
            className={`gap-2 cursor-pointer ${r.id === region ? "bg-emerald-50 font-semibold" : ""}`}
          >
            <span className="text-base leading-none">{r.flag}</span>
            <span className="text-sm">{r.label}</span>
            {r.id === region && <span className="ml-auto text-[10px] text-emerald-700">●</span>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
